import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=0d3c10f6&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=ts&"
export * from "./page-header.vue?vue&type=script&lang=ts&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=0d3c10f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3c10f6",
  null
  
)

export default component.exports